import { AuthProvider } from "@/contexts/AuthContext"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { Toaster } from "@/components/ui/toast"
import LoginPage from "@/pages/LoginPage"
import LogoutPage from "@/pages/LogoutPage"
import ForgotPasswordPage from "@/pages/ForgotPasswordPage"
import ResetPasswordPage from "@/pages/ResetPasswordPage"
import DashboardPage from "@/pages/DashboardPage"
import SettingsPage from "@/pages/SettingsPage"
import UsersListPage from "@/pages/UsersListPage"
import UserProfilePage from "@/pages/UserProfilePage"
import MotoBrandsListPage from "@/pages/MotoBrandsListPage"
import MotoBrandDetailPage from "@/pages/MotoBrandDetailPage"
import ActionPricesListPage from "@/pages/ActionPricesListPage"
import ActionPriceDetailPage from "@/pages/ActionPriceDetailPage"
import PlansListPage from "@/pages/PlansListPage"
import PlanDetailPage from "@/pages/PlanDetailPage"
import CompaniesListPage from "@/pages/CompaniesListPage"
import CompanyDetailPage from "@/pages/CompanyDetailPage"
import AdsListPage from "@/pages/AdsListPage"
import AdDetailPage from "@/pages/AdDetailPage"
import MotoGearCategoriesListPage from "@/pages/MotoGearCategoriesListPage"
import MotoGearCategoryDetailPage from "@/pages/MotoGearCategoryDetailPage"
import ProtectedRoute from "@/components/ProtectedRoute"

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/users" element={<UsersListPage />} />
            <Route path="/users/:id" element={<UserProfilePage />} />
            <Route path="/moto-brands" element={<MotoBrandsListPage />} />
            <Route path="/moto-brands/:id" element={<MotoBrandDetailPage />} />
            <Route path="/action-prices" element={<ActionPricesListPage />} />
            <Route path="/action-prices/:id" element={<ActionPriceDetailPage />} />
            <Route path="/plans" element={<PlansListPage />} />
            <Route path="/plans/:id" element={<PlanDetailPage />} />
            <Route path="/companies" element={<CompaniesListPage />} />
            <Route path="/companies/:slug" element={<CompanyDetailPage />} />
            <Route path="/ads" element={<AdsListPage />} />
            <Route path="/ads/:id" element={<AdDetailPage />} />
            <Route path="/moto-gear-categories" element={<MotoGearCategoriesListPage />} />
            <Route path="/moto-gear-categories/:id" element={<MotoGearCategoryDetailPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  )
}
